export const isTrue = (value: string) => (typeof value === "boolean" && value) || value == "true";